/*************************
  🚨 Auto-generated file. Do not modify directly!
  🚨 Instead, modify ./svg-template.ts or the SVG file
  🚨 See packages/bundler for more info
*************************/
import * as React from 'react';
import type { SVGIconProps } from '../types';
/**
 * SVG icon component.
 */
export function ListTasks({
  className,
  size,
  style
}: SVGIconProps) {
  const props = {
    preserveAspectRatio: 'xMidYMid meet',
    className,
    style: {
      verticalAlign: 'middle',
      ...style
    },
    width: size ?? '1em',
    height: size ?? '1em'
  };
  return <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16" {...props}><path fill="currentColor" d="M6.9 3a.6.6 0 0 1 .6-.6h7a.6.6 0 1 1 0 1.2h-7a.6.6 0 0 1-.6-.6M6.9 13a.6.6 0 0 1 .6-.6h7a.6.6 0 0 1 0 1.2h-7a.6.6 0 0 1-.6-.6M6.9 8a.6.6 0 0 1 .6-.6h7a.6.6 0 1 1 0 1.2h-7a.6.6 0 0 1-.6-.6M5.882 4.538a.6.6 0 0 1 .08.844l-2.892 3.5a.6.6 0 0 1-.905.024L.558 7.156a.6.6 0 1 1 .884-.812l1.141 1.243 2.455-2.97a.6.6 0 0 1 .844-.08M5.882 9.538a.6.6 0 0 1 .08.844l-2.892 3.5a.6.6 0 0 1-.905.024l-1.607-1.75a.6.6 0 0 1 .884-.812l1.141 1.243 2.455-2.97a.6.6 0 0 1 .844-.08" /></svg>;
}
;